const BaseElement = require('./element.base')
const ButtonfieldElement = require('./element.buttonfield')
const ButtonsetElement = require('./element.buttonset')
const CheckboxElement = require('./element.checkbox')
const RadioElement = require('./element.radio')
const RadiosetElement = require('./element.radioset')
const SelectElement = require('./element.select')


const ElementTypes = {
    'button': BaseElement,
    'buttonfield': ButtonfieldElement,
    'buttonset': ButtonsetElement,
    'checkbox': CheckboxElement,
    'email': BaseElement,
    'file': BaseElement,
    'hidden': BaseElement,
    'url': BaseElement,
    'password': BaseElement,
    'radio': RadioElement,
    'radioset': RadiosetElement,
    'reset': BaseElement,
    'search': BaseElement,
    'select': SelectElement,
    'submit': BaseElement,
    'tel': BaseElement,
    'text': BaseElement,
    'number': BaseElement,
    'textarea': BaseElement,
}

module.exports = ElementTypes
